import { render, staticRenderFns } from "./PeiXunManager.vue?vue&type=template&id=659ffe50"
import script from "./PeiXunManager.vue?vue&type=script&lang=js"
export * from "./PeiXunManager.vue?vue&type=script&lang=js"
import style0 from "./PeiXunManager.vue?vue&type=style&index=0&id=659ffe50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports